import{useMemo as r}from"react";import t from"./useForceUpdate.js";function e(e){var n=t();return r((function(){var r=e;return{get current(){return r},set current(t){t&&(r=t,n())}}}),[])}export default e;
